export const SENT_BRANCH_INVITE_START = 'SENT_BRANCH_INVITE_START';
export const SENT_BRANCH_INVITE_SUCCESS = 'SENT_BRANCH_INVITE_SUCCESS';
export const SENT_BRANCH_INVITE_ERROR = 'SENT_BRANCH_INVITE_ERROR';
export const UPDATE_CONFIG_START = 'UPDATE_CONFIG_START';
export const UPDATE_CONFIG_SUCCESS = 'UPDATE_CONFIG_SUCCESS';
export const UPDATE_CONFIG_ERROR = 'UPDATE_CONFIG_ERROR';
export const LOAD_CONFIG_START = 'LOAD_CONFIG_START';
export const LOAD_CONFIG_SUCCESS = 'LOAD_CONFIG_SUCCESS';
export const LOAD_CONFIG_ERROR = 'LOAD_CONFIG_ERROR';
